module.exports = __webpack_public_path__ + "static/Brumbrum-f1bd23cdb956b52d3d0f74875fa37631.png";